import { Button, tokens } from "@blurb/codex-react";
import { Flex, IconV3 } from "@rpi/openapi-core";
import React from "react";
import { Heading } from "../../../components/Typography";
import { RpiCard } from "../../../rpi-core/card/RpiCard";

interface AccountSettingsCardProps {
  title: string;
  onEdit?: () => void;
  children: React.ReactNode;
  "data-testid"?: string;
}

/** White section card with a title and an optional Edit button, per the Account Settings design. */
export const AccountSettingsCard: React.FC<AccountSettingsCardProps> = ({ title, onEdit, children, ...rest }) => (
  <RpiCard {...rest}>
    <Flex.Column gap={16} p={24} fullWidth sx={{ color: tokens.color.semantic.text.bold, height: "100%" }}>
      <Flex.Row justify="space-between" align="center" gap={16} fullWidth>
        <Heading size="3xl">{title}</Heading>
        {onEdit && (
          <Button
            variant="outlined"
            intent="neutral"
            size="small"
            aria-label={`Edit ${title}`}
            iconRight={<IconV3 icon="edit" size={16} />}
            onClick={onEdit}
          >
            Edit
          </Button>
        )}
      </Flex.Row>

      {children}
    </Flex.Column>
  </RpiCard>
);
